import React, { lazy } from "react";
import {
  Route,
  defer,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import { AuthLayout } from "../components/template/AuthLayout";
import { getAuthData } from "../utils/LocalStorageManager";



/** Template */
const HomeLayout = lazy(() => import("../components/template/HomeLayout"));
const BoardLayout = lazy(() => import("../components/template/BoardLayout"));

/** Main page */
const Login = lazy(() => import("../pages/public/login/Login"));

/** Board entreprise or bac home page */
const Home = lazy(() => import("../pages/board/home/Home"));

/** Board user profile */
const Profile = lazy(() => import("../pages/board/profile/Profile"));

/** Board search page */
const SHSinpe = lazy(() => import("../pages/board/search/sinpe/SHSinpe"));
const SHTransaction = lazy(() =>
  import("../pages/board/search/transaction/SHTransaction")
);
const SHPreregister = lazy(() =>
  import("../pages/board/search/preregister/SHPreregister")
);

const SHCommissionsVat = lazy(() =>
  import("../pages/board/search/commisionVat/SHCommissionsVat")
);

/** Board management page */
const Organization = lazy(() =>
  import("../pages/board/management/organization/Organization")
);

/** Board management page */
const Segment = lazy(() =>
  import("../pages/board/management/segment/Segment")
);

/** Board management page */
const Configuration = lazy(() =>
  import("../pages/board/management/configuration/Configuration")
);

/** Board maintenance page */
const System = lazy(() =>
  import("../pages/board/maintenance/system/System")
);

/** Board maintenance page */
const Device = lazy(() =>
  import("../pages/board/maintenance/system/Device")
);

/** Board maintenance page */
const Terminals = lazy(() =>
  import("../pages/board/maintenance/system/DeviceTerminals")
);

const UserDevice = lazy(() =>
  import("../pages/board/maintenance/system/UserDevice")
);

const ServiceType = lazy(() =>
  import("../pages/board/maintenance/servicetype/ServiceType")
);

const Phone = lazy(() =>
  import("../pages/board/maintenance/phone/Phone")
);

const PhoneService = lazy(() =>
  import("../pages/board/maintenance/phoneservice/PhoneService")
);

const Affiliate = lazy(() =>
  import("../pages/board/maintenance/affiliate/Affiliate")
);

const Terminal = lazy(() =>
  import("../pages/board/maintenance/affiliate/Terminal")
);

const Plan = lazy(() =>
  import("../pages/board/maintenance/plan/Plan")
);

const PreauthorizedAmounts = lazy(() =>
  import("../pages/board/maintenance/preauthorizedAmounts/PreauthorizedAmounts")
);

/** Board security page */
const User = lazy(() =>
  import("../pages/board/security/user/User")
);

const UserGroup = lazy(() =>
  import("../pages/board/security/usergroup/UserGroup")
);

const OptionGroup = lazy(() =>
  import("../pages/board/security/optiongroup/OptionGroup")
);

const Group = lazy(() =>
  import("../pages/board/security/group/Group")
);

const Option = lazy(() =>
  import("../pages/board/security/option/Option")
);

/*****************************************************************************
 * REVISION 1.0
 * Fecha: 07/06/2024
 *
 * @description componente padre para manejo de rutas en la app
 * @author luis.ferrer
 * @version 1.0
 *
 ****************************************************************************/
export const appRoutes = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={<AuthLayout />}
      loader={async () => defer({ authPromise: getAuthData() })}
    >
      <Route element={<HomeLayout />}>
        <Route exact path="/" element={<Login />} />
      </Route>
      <Route path="/board" element={<BoardLayout />}>
        <Route exact path="home" element={<Home />} />
        <Route exact path="profile" element={<Profile />} />
        <Route exact path="search/sinpe" element={<SHSinpe />} />
        <Route exact path="search/transaction" element={<SHTransaction />} />
        <Route exact path="search/commissionsvat" element={<SHCommissionsVat/>} />
        <Route exact path="search/preregister" element={<SHPreregister />} />
        <Route exact path="management/organization" element={<Organization />} />
        <Route exact path="management/segment" element={<Segment />} />
        <Route exact path="management/configuration" element={<Configuration />} />
        <Route exact path="maintenance/system" element={<System />} />
        <Route exact path="maintenance/device" element={<Device />} />
        <Route exact path="maintenance/terminals" element={<Terminals />} />
        <Route exact path="maintenance/userdevice" element={<UserDevice />} />
        <Route exact path="maintenance/servicetype" element={<ServiceType />} />
        <Route exact path="maintenance/phone" element={<Phone />} />
        <Route exact path="maintenance/phoneservice" element={<PhoneService />} />
        <Route exact path="maintenance/affiliate" element={<Affiliate />} />
        <Route exact path="maintenance/terminal" element={<Terminal />} />
        <Route exact path="maintenance/plan" element={<Plan />} />
        <Route exact path="maintenance/preauthorizedAmounts" element={<PreauthorizedAmounts/>} />
        <Route exact path="security/user" element={<User />} />
        <Route exact path="security/usergroup" element={<UserGroup />} />
        <Route exact path="security/group" element={<Group />} />
        <Route exact path="security/option" element={<Option />} />
        <Route exact path="security/optiongroup" element={<OptionGroup />} />
      </Route>
    </Route>
  ),
  { basename: "/portal-web" }
);
